import { render, staticRenderFns } from "./CreateDebtor.vue?vue&type=template&id=ba137646&"
import script from "./CreateDebtor.vue?vue&type=script&lang=js&"
export * from "./CreateDebtor.vue?vue&type=script&lang=js&"
import style0 from "./CreateDebtor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports